// extracted by mini-css-extract-plugin
export default {"content":"style_content__jvPRh","checkbox":"style_checkbox__PV9qX"};